/*
 * @Author: cn1994
 * @Date: 2023-01-08 14:52:50
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-31 15:54:30
 * @Description: 全局注入lsUI
 */
// 下拉菜单
import LsDropdown from './dropdown/index.vue'
// 按钮
import LsButton from './button/index.vue'
// 图片
import LsImage from './image/index.vue'
// 输入框
import LsInput from './input/index.vue'
// tooltip
import LsTooltip from './tooltip/index.vue'
// tag
import LsTag from './tag/index.vue'
// tab
import LsTabs from './tabs/index.vue'
// select
import LsSelect from './select/index.vue'
// timePicker
import LsTimePicker from './timePicker/index.vue'
// dialog
import LsDialog from './dialog/index.vue'
// drawer
import LsDrawer from './drawer/index.vue'
// 文字显示
import LsText from './text/index.vue'

const component = {
  install: function (Vue) {
    Vue.component(LsDropdown.name, LsDropdown),
    Vue.component(LsButton.name, LsButton),
    Vue.component(LsImage.name, LsImage),
    Vue.component(LsInput.name, LsInput),
    Vue.component(LsTooltip.name, LsTooltip),
    Vue.component(LsTag.name, LsTag),
    Vue.component(LsTabs.name, LsTabs),
    Vue.component(LsSelect.name, LsSelect),
    Vue.component(LsTimePicker.name, LsTimePicker),
    Vue.component(LsDialog.name, LsDialog),
    Vue.component(LsDrawer.name, LsDrawer),
    Vue.component(LsText.name, LsText)
  }
}

export default component
